module.exports = __webpack_public_path__ + "img/EX2_memory_new.8811eb69.jpg";